export default __webpack_public_path__ + "static/media/Maya.55016cd1.png";